package com.macrofocus.nastac.book

import com.macrofocus.nastac.components.link.*
import react.FC
import react.Props

data class Chapter(val id: String, val number: String?, val title: String, val filename: String, val fileSize: String, val sources :List<FC<Props>> = emptyList())

public val chapters = listOf(
    Chapter("intro", null, "Introduction", "nastac-book-introduction", "194K"),
    Chapter("c04", "4", "War and State Formation in Early Modern Europe", "nastac-book-chapter04", "1.8G"),
    Chapter("c05", "5", "Nationalism and the Puzzle of Reversing State Size", "nastac-book-chapter05", "258M", listOf(CShapesEuropeLink, CShapesLink, HEGLink)),
    Chapter("c06", "6", "Shaping States into Nations", "nastac-book-chapter06", "1.1G", listOf(CShapesEuropeLink, HEGLink)),
    Chapter("c07", "7", "Nationality Questions and War", "nastac-book-chapter07", "15M", listOf(CShapesEuropeLink, HEGLink)),
    Chapter("c08", "8", "Restorative Nationalism and War", "nastac-book-chapter08", "18M", listOf(CShapesEuropeLink, HEGLink)),
    Chapter("c09", "9", "Railroads, Separatist Mobilization, and Conflict", "nastac-book-chapter09", "285M", listOf(CShapesEuropeLink, HEGLink, RShapesLink)),
    Chapter("c10", "10", "Nationalism, Right-Peopling, and Ethnic Cleansing", "nastac-book-chapter10", "18M", listOf(CShapesEuropeLink, HEGLink)),
    Chapter("c11", "11", "Conclusions for Research and Practice", "nastac-book-chapter11", "95M", listOf(CShapesLink, EPRLink))
)